import Vue from "vue";
import Vuetify from "vuetify/lib";
import "@mdi/font/css/materialdesignicons.css";
import SentimentIcon from "@/components/common/icons/SentimentIcon.vue";
import { PRIMARY_COLOR, SECONDARY_COLOR } from "@/common/config";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    values: {
      sentiment: {
        component: SentimentIcon,
        props: {
          name: "sentiment",
        },
      },
    },
  },
  theme: {
    themes: {
      light: {
        primary: PRIMARY_COLOR,
        secondary: SECONDARY_COLOR,
      },
      dark: {
        primary: PRIMARY_COLOR,
        secondary: SECONDARY_COLOR,
      },
    },
  },
});
